// The pass, one tap away on every screen (redesign 2026-09-27): a button pinned above the tabs
// that opens the rotating pickup code in a sheet, so it no longer needs its own tab.
import { useEffect, useState } from "react";
import { Icon, Sheet } from "@vavr/ui";
import { PickupCode } from "./PickupCode.tsx";
import { useGuardian } from "./context.tsx";

// "Show my pass" on the live lock-screen card: the pass opens as soon as the button is on screen,
// even when the tap cold-started the app and the button mounts later.
let passAsked = false;
const passEvents = new EventTarget();
export function askForPass() { passAsked = true; passEvents.dispatchEvent(new Event("open")); }

export function PassButton() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const take = () => { if (passAsked) { passAsked = false; setOpen(true); } };
    take();
    passEvents.addEventListener("open", take);
    return () => passEvents.removeEventListener("open", take);
  }, []);
  const { platform } = useGuardian();
  const [nfc, setNfc] = useState<"on" | "off" | null>(null);
  useEffect(() => { platform.nfcPass?.status().then((x) => setNfc(x.supported ? (x.enabled ? "on" : "off") : null), () => undefined); }, [platform, open]);
  // While the pass is on screen the phone is only a card, so a staff phone's tap is not dropped.
  useEffect(() => {
    if (!open || !platform.nfcPass) return;
    void platform.nfcPass.setCardOnly(true);
    return () => { void platform.nfcPass?.setCardOnly(false); };
  }, [open, platform]);
  return (
    <>
      <button type="button" className="pmg-passbtn" onClick={() => setOpen(true)} aria-haspopup="dialog">
        <span className="pmg-passbtn__icon" aria-hidden="true"><Icon name="qr" /></span>
        <span className="pmg-passbtn__text"><b>Show my pass</b><small>Hold it up to the door tablet</small></span>
        <Icon name="chevron-right" />
      </button>
      <Sheet open={open} onOpenChange={setOpen} title="Your pass" description="Hold it up to the camera on the door tablet.">
        {open && <PickupCode />}
        {open && nfc === "on" && <p className="pmg-nfc pmg-nfc--ready"><Icon name="phone" /> Ready to tap: hold the back of your phone to the staff member's phone. It buzzes when your pass is read.</p>}
        {open && nfc === "off" && <p className="pmg-nfc"><Icon name="phone" /> Turn on NFC in your phone's settings to tap your phone instead.</p>}
      </Sheet>
    </>
  );
}
